import { render, staticRenderFns } from "./bootsprop.vue?vue&type=template&id=532a6734&scoped=true&"
import script from "./bootsprop.vue?vue&type=script&lang=js&"
export * from "./bootsprop.vue?vue&type=script&lang=js&"
import style0 from "./bootsprop.vue?vue&type=style&index=0&id=532a6734&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532a6734",
  null
  
)

export default component.exports